export default "__VITE_ASSET__fUd3f1su__"